// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyARiz7VkFwi3FJQpGm0lMcnxuToz3g08NM",
  authDomain: "sharvaclinic-be92b.firebaseapp.com",
  projectId: "sharvaclinic-be92b",
  storageBucket: "sharvaclinic-be92b.firebasestorage.app",
  messagingSenderId: "1005766749468",
  appId: "1:1005766749468:web:278886ceac7c417b9cded9",
  measurementId: "G-LGX44VH758"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);